import React, {Component} from 'react';
import {ChannelLogo} from "../channels/ChannelLogo";
import {AddClientAdAccountButtonWithModal} from "../client/ad_accounts/AddClientAdAccountButtonWithModal";
import { withTranslation } from 'react-i18next';

class IgnoredAdAccountRowClass extends Component {
    constructor(props) {
        super(props);
        this.handleAssignToClient = this.handleAssignToClient.bind(this);
    }

    handleAssignToClient() {
        this.props.onAssignToClient(this.props.adAccount.id)
    }

    render() {
        return (
            <tr key={this.props.adAccount.id}>
                <td style={{paddingLeft: '0.4em'}}>
                    {this.renderAccountColumnText()}
                </td>
                <td>
                    <span>{this.props.snoozeInfo.snooze_by_email}<br/>{this.props.snoozeInfo.snooze_on}</span>
                </td>
                <td>
                    <div>
                        <AddClientAdAccountButtonWithModal channel={this.props.adAccount.channel}
                                                           adAccountId={this.props.adAccount.account_id}
                                                           afterSuccessfulSubmit={this.props.onAssignToClient}
                                                           buttonClassName={""}
                                                           buttonText={""}
                                                           buttonTitle={this.props.t('clients.link_ad_account_button')}
                                                           buttonIconName={"plus-square"}

                        />
                    </div>
                </td>
            </tr>
        );
    }

    renderAccountColumnText() {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} width={"20px"} height={"20px"} marginLeft={"0px"} channel={this.props.adAccount.channel}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {this.props.adAccount.account_id}<br/>{this.props.adAccount.name}
                </span>
            </div>
        )
    }
}

export const IgnoredAdAccountRow = withTranslation()(IgnoredAdAccountRowClass);
